import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import { SubscriptionPlansService } from './service/subscription-plans.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from '../signup/service/signup.service';
import {BroadcastService} from "@azure/msal-angular";
import { MsalService} from "@azure/msal-angular";
import { ServiceUrlsService } from '../common-service/service-urls/service-urls.service';


@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss']
})
export class SubscriptionPlansComponent implements OnInit {

  subscriptionMessage: string;
  subscriptionError = false;
  subscriptionSuccess =  false;
  packageSubscriptionSuccess =  false;
  customerIdInStorage = false;
  public userInfo: any = null;

  msSignupEmail: string;



  constructor(private localStorageService: LocalStorageService,
              private subscriptionPlansService: SubscriptionPlansService,
              private spinnerService: NgxSpinnerService,
              private activetedRoute: ActivatedRoute,
              private router: Router,
              private signupService: SignupService,
              private authService : MsalService,
              private serviceUrlsService: ServiceUrlsService
            ) { }

  ngOnInit() {
      this.subscriptionSuccess =  true;

      this.userInfo = this.authService.getUser();

      console.log('-------Inside signup success-------');

      console.log(this.userInfo);
      console.log(this.localStorageService.getUserType());
      console.log(this.localStorageService.getCustomerId());

      if(this.localStorageService.getUserType() !== 'NATIVE_USER') {
        // const clientName =  this.userInfo.name === undefined ? 'Customer' : this.userInfo.name;
        // const contactName = this.userInfo.name === undefined ? 'User' : this.userInfo.name;
        // const contactEmail= this.userInfo.displayableId;
        // const contactPhone= '';
        //this.registerClient(signUpObject);


        this.signUpWithMicrosoft();
      } else {

        console.log('Not MS USER : '+this.localStorageService.getCustomerId());
        this.subscriptionError = false;
        this.subscriptionMessage = '<div class="row text-center"><strong>Congratulations!!</strong> You have successfully signed up!</div><hr>Please choose a plan to subscribe Executive-Eye';
        this.customerIdInStorage = this.localStorageService.getCustomerId() === null ? false : true;
      }

  }

  msSignup() {
        //this.authService.loginRedirect(["user.read"]);
        this.router.navigate(['free-trial']);
  }

  subscribeTrialPlan() {

    const customerId =  this.localStorageService.getCustomerId();
    const trialPlanObject = {customerId: customerId};

    this.spinnerService.show();

    console.log(customerId===null);

    if(customerId === null || customerId === undefined) {

      this.subscriptionError = false;
      this.subscriptionSuccess =  true;
      this.packageSubscriptionSuccess =  true;
      this.subscriptionMessage = '<div class="row text-center"><strong>Congratulations!</strong> You have successfully subscribed for <b>Trial Plan</b>.</div>'+
                '<hr>Your Executive Eye credentials and subscription details has been sent to your registered email. '+
                '<br><br>Please <a (click)="goToXeyePortal();">click here</a> to login with <a (click)="goToXeyePortal();">Executive Eye</a> ';
      this.spinnerService.hide();

    } else {


     this.subscriptionPlansService.subscribeTrialplan(trialPlanObject).subscribe(response => {
        let status = response.code;
        console.log(response);
        if (status === '200' || status === 200) {

             this.subscriptionError = false;
             this.subscriptionSuccess =  true;
             this.packageSubscriptionSuccess =  true;
             this.subscriptionMessage = '<div class="row text-center"><strong>Congratulations!</strong> You have successfully subscribed for trial plan.</div><hr>Please <a href="javascript: void(0);"  click="gotoXeyePortal();">click here</a> to login to Executive Eye';
             this.localStorageService.removeCustomerId();
             this.localStorageService.removeUserType();
             this.spinnerService.hide();
             this.router.navigate(['signup-success']);

        } else {
              this.spinnerService.hide();
               this.subscriptionError = true;
                this.subscriptionSuccess =  false;
                this.packageSubscriptionSuccess =  false;
                 this.subscriptionMessage  = 'An error occared while subscribe trial plan.';
        }
    },
      err => {
        console.log(err);
           this.spinnerService.hide();
           this.subscriptionError = true;
            this.subscriptionSuccess =  false;
            this.packageSubscriptionSuccess =  false;
           this.subscriptionMessage  = 'An error occared while subscribe trial plan.';
    });
    }
  }

  goToXeyePortal(): void {
    window.open("https://portal.executive-eye.com", "_blank");

  }

  registerClient(signUpObject) {

         this.spinnerService.show();

          this.signupService.signup(signUpObject).subscribe(response => {
             let code = response.code;
             console.log(response);
             if (code === '200' || code === 200) {
                 this.localStorageService.removeUserType();
                 this.localStorageService.removeCustomerId();
                 this.localStorageService.saveCustomerId(response.object.id);
                 this.localStorageService.saveUserType("MS_USER");
                 this.spinnerService.hide();
                 this.subscriptionError = false;
                 //this.subscriptionMessage = '<div class="row text-center"><strong>Congratulations!!</strong> You have successfully signed up!</div><hr>Please choose a plan to subscribe Executive-Eye';
                 //this.customerIdInStorage = this.localStorageService.getCustomerId() === null ? false : true;

                this.subscribeTrialPlan();
                // this.router.navigate(['signup-success']);
             } else {
                 this.subscriptionError =  true;
                 this.subscriptionMessage = response.message;
                 this.spinnerService.hide();
             }
         },
           err => {
                console.log(err);
                this.subscriptionError =  true;
                this.subscriptionMessage = err.errorMessage;
                this.spinnerService.hide();
         });
  }

  signUpWithMicrosoft() {
      this.subscriptionError =  false;
      console.log(this.userInfo);

      this.msSignupEmail = this.userInfo.displayableId;

      this.spinnerService.show();

       this.signupService.getMsAccessToken(this.msSignupEmail).subscribe(response => {
          let errorCodes = response.object.error_codes;
          console.log(response);

          console.log(errorCodes);
          if (errorCodes === undefined && !response.clientAlreadyRegistered) {
              //this.msSignUpErrorMessage = response.message;
              this.subscriptionError =  false;

              const responseobjectBody = JSON.parse(response.object);

              console.log(responseobjectBody);

              this.localStorageService.saveMSAccessToken(responseobjectBody.access_token);
              //this.spinnerService.hide();
              console.log('inside if');

              if(responseobjectBody.error_codes !== undefined && responseobjectBody.error_codes.length > 0) {
                    this.subscriptionError =  true;
                    this.subscriptionMessage = responseobjectBody.error_description;
                    this.spinnerService.hide();
              } else {
                 this.sendAzureADInvitation();
              }

              //Error Case
              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
              this.subscriptionError =  true;
              this.subscriptionMessage = response.message;
              console.log('inside else');
              this.spinnerService.hide();
              //this.spinnerService.hide();
          }
      },
        err => {

          console.log('inside error');
              console.log(err);
             this.subscriptionError =  true;
             this.subscriptionMessage = err.message;
             this.spinnerService.hide();
      });

    }

  sendAzureADInvitation() {

    console.log('inside ------ sendAzureADInvitation');

    this.spinnerService.show();

    const  msSigninRequestObject = {invitedUserEmailAddress: this.msSignupEmail,
                                    inviteRedirectUrl: this.serviceUrlsService.msRedirectUrl
                                   };
       this.signupService.sendAzureADInvitation(msSigninRequestObject).subscribe(response => {
          let errorCodes = response.error_codes;
          console.log(errorCodes)
          console.log(response);
          if (errorCodes === undefined || errorCodes === 'undefined') {

              this.subscriptionError =  false;
              //this.msSignUpErrorMessage = response.message;
              const inviteRedeemUrl = response.inviteRedeemUrl
              let msUserDisplayName = response.invitedUserDisplayName;
              const msUserEmail = response.invitedUserEmailAddress;

              if(msUserDisplayName == undefined) {
                 msUserDisplayName   = msUserEmail.substring(0, msUserEmail.lastIndexOf("@"));
              }

              this.localStorageService.saveMSUserDisplayName(msUserDisplayName);
              this.localStorageService.saveMSUserEmail(msUserEmail);

              const signUpObject = {contactName: msUserDisplayName, contactEmail: msUserEmail,
                                    clientName: msUserDisplayName, contactPhone: '',
                                    clientType: 'MS_USER',
                                   };

              console.log(signUpObject);

              this.registerClient(signUpObject);

              //this.router.ngOnDestroy();
              //window.open(inviteRedeemUrl, '_self');

              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
            this.subscriptionMessage = response.message;
            this.subscriptionError =  true;
            this.spinnerService.hide();
          }
      },
        err => {
              console.log(err);
             this.subscriptionError =  true;
             this.subscriptionMessage = err.message;
             this.spinnerService.hide();
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/subscription-plans/subscription-plans.component.ts